<main>
  <div class="container">
    <div id="tabs-primary" class="row">
      <div class="col-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      </div>
    </div>
    <!-- <form method="post" action="./" id="form1"> -->
      <div id="siteContent" class="row">
        <div id="info" class="col-12 col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <h2 id="page-title">Welcome to the <span [ngStyle]="{ color: primaryColor }">{{nameHomePage}} Resource Centre</span></h2>
          <div id="node-1" class="col col-lg-12 col-md-12 col-sm-12 col-xs-12 clearfix">
            <!-- <markdown [data]="desHomePage"></markdown> -->
             <app-render-markdown [markdownData]="desHomePage"/>
          </div>
        </div>
        <div id="menu" class="col-12 col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <app-product-list [products]="products" />
        </div>
      </div>


      <!-- <script async="" src="https://www.googletagmanager.com/gtag/js?id=G-RL6GV30N4D"></script>
      <script>window.dataLayer = window.dataLayer || []; function gtag() { dataLayer.push(arguments); } gtag('js', new Date()); gtag('config', 'G-RL6GV30N4D');</script> -->
    <!-- </form> -->
  </div>
</main>
